export const enableDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => {
});